<template>
    <Modal v-model="modalVisible" :width="1200" :height="300" scrollable class-name="vertical-center-modal" @on-cancel="cancal" >
        <p slot="header">
            <span>按模板新增产品</span>
        </p>
        <Form ref="productForm" :label-width="100">
            <Row :gutter="8">
                <Col span="12">
                <FormItem label="选择产品名称">
                    <Select v-model="productSelectCode"  clearable filterable >
								<Option v-for="item in productList"  
									:key="item.productUuid" :value="item.productCode">
									{{ item.productName }}
								</Option>
							</Select>   
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="产品编码" v-if="productSelectCode">
                    <Input :value="productSelectCode" readonly />
                </FormItem>
                </Col>
                <Col span="0">
                </Col>
            </Row>
        </Form>
  
        <div slot="footer">
            <Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
			@click="insertTempSumbit">以此产品为模板新增产品</Button>
        </div>
    </Modal>
</template>

<script>
import { getProductList } from '@/api/modules/product-management/product-management';
import Loading from '@/components/loading/Loading.vue';
import ProductPopupEdit from './product-popup-edit-new-info';

import ModalVisible from '@/view/mixins/modal-visible';



export default {
    name: 'ProductPopupEditBaseBath',
	 mixins: [ModalVisible],
    props: {
        productUuidsBathEdit: {
            type: Array,
            default: function () {
                return [];
            }
        }
	
    },
    data() {
        return {
            productList:[],        
            productSelectCode:'',
            saveLoading:false
        };
    },
    mounted(){
        this.getAllProductList();
    },
    methods: {
        cancal(){
            this.modalVisible=false;
            this.productSelectCode='';
        },
        insertTempSumbit(){
            if(!this.productSelectCode){
                this.$Message.error('产品编码不能为空');
                return;
            }
            this.$emit('insert-by-template');
            this.cancal();
        },
        getAllProductList(){
            let condition = this.getCondition(); 
            condition.filters.conditions.push({
                name: 'isShow',
                type: 'eq',
                value: 1
            });
         
            getProductList(condition).then(res => {
                if (res.code === 0) {
                    this.productList = res.data.records;                 
                } 
            });
        },
        getCondition(){
            let condition = {
                filters: {
                    enable: true,
                    conditions: []
                },
                order: {
                    enable: false,
                    conditions: []
                },
                limit: {
                    enable: false,
                    conditions: {
                        pageLength: 10,
                        pageStart: 1,
                        total: 0
                    }
                },
                excelExport: {
                    enable: false,
                    columns: []
                }
            };   
            return condition;
        }
		
    },
	
    computed:{

    }
};
</script>

<style lang="less">
.ivu-select-input {
  width: 100% !important;
  left: 0 !important;  /* 确保下拉框和筛选框的左边对齐 */
}
.iv-select-dropdown {
  width: 100% !important;
  text-align: left !important;
}

</style>
